module.exports = __webpack_public_path__ + "static/media/10.113a9070.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/10.mp3
// module id = 89
// module chunks = 0